(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fortmix-header-search"] && !Shopify.designMode) return;
  try {
    class FortmixHeaderSearch extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.predictiveSearch = this.querySelector('predictive-search');
      if (!this.predictiveSearch) return;
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onClick(event) {
      if (!event.target.closest('[data-fortmix-search-close]')) return;
      this.closeSuggestions();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (!this.predictiveSearch.isOpen && !this.predictiveSearch.hasAttribute('loading')) return;
      event.preventDefault();
      event.stopPropagation();
      this.closeSuggestions();
    }

    closeSuggestions() {
      const input = this.predictiveSearch.input;
      if (document.activeElement === input || this.predictiveSearch.hasAttribute('results')) {
        input.focus();
      } else {
        this.querySelector('button[type="submit"]').focus();
      }
      this.predictiveSearch.abortController.abort();
      this.predictiveSearch.abortController = new AbortController();
      this.predictiveSearch.close();
    }
  }

  if (!customElements.get('fortmix-header-search')) {
    customElements.define('fortmix-header-search', FortmixHeaderSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
